<template>
  <v-card flat tile>
    <v-window
      v-model="onboarding"
      reverse
      show-arrows
      continuous
    >
      <v-window-item
        v-for="p in photos"
        :key="`card-${p.id}`"
      >
        <v-card
          flat
          color="transparent"
          height="400"
        >
          <v-row
            class="fill-height"
            align="center"
            justify="center"
            tag="v-card-text"
          >

             <v-dialog
              v-model="dialog"
              persistent
              width="500"
              max-width="90vw"
            >
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                >
                  <img :src="p.media_url" height="400" alt="InstagramURL"/>
                </div>
              </template>
              <v-card>
                <v-card-title
                  class="d-flex justify-space-between headline grey lighten-2"
                  primary-title
                >
                  {{ formatDate(p.timestamp) }}
                  <v-btn
                    icon
                    href="https://www.instagram.com/dogsalonfree/"
                  >
                    <v-icon color="purple">mdi-instagram</v-icon>
                  </v-btn>
                  <v-btn
                    color="red"
                    dark
                    @click="dialog = false"
                  >
                    閉じる
                  </v-btn>
                </v-card-title>
                <v-card-text class="text--caption">
                  {{ p.caption }}
                </v-card-text>
                <v-divider></v-divider>
              </v-card>
            </v-dialog>

          </v-row>
        </v-card>
      </v-window-item>
    </v-window>

  </v-card>
</template>

<script>
export default {
  name: 'SnsCards',
  props: {
    photos: Array,
  },
  data(){
    return {
      onboarding: 0,
      dialog: false,
    }
    // return {
    //   isIntersecting: false,
    // }
  },
  computed: {
    length() {
      return this.photos.length
    }
  },
  methods: {
    next () {
      this.onboarding = this.onboarding + 1 === this.length
        ? 0
        : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? this.length - 1
        : this.onboarding - 1
    },
    formatDate(timestamp) {
      const year = timestamp.substr(0,4)
      const month = timestamp.substr(5,2)
      const day = timestamp.substr(8,2)

      return `${year}年${month}月${day}日`
    },
  }
}
</script>

<style>
.center {
  margin:0 auto;
}
.text--caption {
  font-size: 10px;
  white-space: pre-wrap;
}
</style>
